<template>
    <div class="footer">
        <div class="information">
            <p>
                <span>客服QQ：1323808040</span>
                <span>Email：mylibs@163.com</span>
                <span>联系微信：mysql365</span>
            </p>
            <p>
                <span>Copyright</span>
                <span><a href="https://beian.miit.gov.cn/">蜀ICP备20005939号-2</a></span>
                <span>www.link2lib.com</span>
                <span>All Rights Reserved</span>
                <span><img src="./../../public/pic.gif" alt=""></span>
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        }
    }
</script>
<style scoped>
    .footer {
        height: 100px;
    }

    .information {
        width: 1030px;
        margin: 0 auto;
        text-align: center;
        border-top: 1px solid #326fab;
    }

    .information P {
        margin-top: 20px;
    }

    .information span {
        font-size: 13px;
        /* font-weight: 600; */
        padding: 0 10px;
    }
</style>